import React from 'react';
import { Tag } from 'antd';

export const isApplicationSubmitted = (application) =>
  Boolean(application?.submitted_at);

export const getApplicationSubmissionState = (application, t) =>
  isApplicationSubmitted(application)
    ? {
        value: 'submitted',
        label: t('Odovzdaná'),
        color: 'green',
      }
    : {
        value: 'draft',
        label: t('Rozpracovaná'),
        color: 'gold',
      };

export const renderApplicationSubmissionTag = (application, t) => {
  const state = getApplicationSubmissionState(application, t);
  return <Tag color={state.color}>{state.label}</Tag>;
};

export const PHD_APPLICATION_CHANGE_CONTACT_MESSAGE =
  'V prípade potreby vykonania zmeny potvrdenej prihlášky je potrebné kontaktovať Referát pre doktorandské štúdium a kariérny rast.';
